import { render } from "./EmailMange.vue?vue&type=template&id=0cae9709&scoped=true"
import script from "./EmailMange.vue?vue&type=script&lang=js"
export * from "./EmailMange.vue?vue&type=script&lang=js"

import "./EmailMange.vue?vue&type=style&index=0&id=0cae9709&lang=scss&scoped=true"
import "./EmailMange.vue?vue&type=style&index=1&id=0cae9709&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cae9709"]])

export default __exports__